import React, { useCallback, useMemo } from 'react';
import { Link } from 'react-router-dom';

import { NotificationManager, SiteConfigManager, StorageManager, useSettings } from '@atlas/core';

import { CXFROM_STORAGE_KEY, LEAVE_SIGNUP_NOTIFICATION_ID } from 'common/constants';
import { CDN_TYPE_CMS, getCDNUrl } from 'common/utils/utils';

const LogoImage = ({ logoSrc, metaTitle }) => {
  if (!logoSrc) return null;

  return <img alt={metaTitle} className="centered-image-logo" src={logoSrc} />;
};

const Logo = ({ linkTo, redirectTo }) => {
  const { theme } = useSettings();
  const metaTitle = SiteConfigManager.getConfig('config.config.seo.default_meta_title', '');
  const leaveSignup = SiteConfigManager.getConfig(
    'config.config.general.leaveRegistrationPopup.enable',
    false,
  );

  const logoImgSrc = useMemo(() => {
    const cdnPathName = getCDNUrl(CDN_TYPE_CMS);
    const logoName = theme === 'dark' ? 'logo_mobile_dark' : 'logo_mobile_light';
    const logo = SiteConfigManager.getConfig(logoName);

    if (!logo) {
      return null;
    }

    return `${cdnPathName}/${logo}`;
  }, [theme]);

  const clickHandler = useCallback(
    e => {
      if (leaveSignup) {
        e.preventDefault();
        NotificationManager.display({
          data: {
            type: 'logoInPopup',
          },
          id: LEAVE_SIGNUP_NOTIFICATION_ID,
          message: 'leaveSignup',
          type: 'leaveSignup',
        });
        return false;
      }
    },
    [leaveSignup],
  );

  if (redirectTo) {
    return (
      <Link
        aria-label={metaTitle}
        className="logo"
        onClick={() => StorageManager.removeItem(CXFROM_STORAGE_KEY)}
        to={redirectTo}
      >
        <LogoImage logoSrc={logoImgSrc} metaTitle={metaTitle} />
      </Link>
    );
  }

  if (linkTo) {
    return (
      <a aria-label={metaTitle} className="logo" href={linkTo} onClick={clickHandler}>
        <LogoImage logoSrc={logoImgSrc} metaTitle={metaTitle} />
      </a>
    );
  }

  return (
    <div className="logo">
      <LogoImage logoSrc={logoImgSrc} metaTitle={metaTitle} />
    </div>
  );
};

export default Logo;
